import axios from 'axios';
import * as Constants from "../../constants"
import { DivIcon, Icon, LatLng, Layer, Map, Marker, Point } from 'leaflet';
import Ray from '../../assets/img/icons-lightning/ray.svg';

export class LightningService {

    lightningReports: any[] = [];
    lastNewMarkers: any[] = [];
    renderedMarkers: any[] = [];
    reportMarkersCoordinates: any[] = [];
    shapes: Layer[] = [];
    map: Map;
    interval: any = null;
    flashTimerId: any = null;
    stopService: boolean = false;

    constructor(map: Map) {
        this.map = map;
    }

    async getLightning() {
        try{
            const response=  await axios.get(Constants.LIGHTNINGS_API_URL ?? '');
            this.lightningReports = this.parseData(response.data);
        }catch (e){
            console.log(e)
            this.lightningReports = [];
        }
        for(let i= 14; i >= 0; i--){
            let isOldPoints = 0;
            await this.getCoordinates(i);
            if(isOldPoints == 14) {
                this.render(false, isOldPoints);
            }else{
                this.render(true, isOldPoints);
            }
            isOldPoints++;
        }
        
    }

    async getCoordinates(point: number, hasTriedPointOne: boolean = false) {
        try{
            if (!this.lightningReports[point]){
                return;
            }
            
            const response = await axios.get(Constants.COORDINATES_API_URL+"?xml="+this.lightningReports[point] ?? '');
            const buffer = this.isJSON(response.data);
            if(buffer.length == 0){
                if (point !== 1 && !hasTriedPointOne) {
                    await this.getCoordinates(1,  true); 
                }
                this.render(false, 0);
            }else{
                this.reportMarkersCoordinates = buffer;
            }
            
        }catch (e){
            console.log(e)
        }
        
        

    }
    
    render(active: boolean, timeMultiplier: number){
        const zoom = this.map.getZoom();
        if(zoom >= 13){
            this.removeMarkers();
            return;
        }
        const markers = this.getVisibleMarkers(this.reportMarkersCoordinates, false, timeMultiplier);
        let newMarkers =[];

        if(active){
            newMarkers = this.lastNewMarkers;
        }else{
            newMarkers = this.getNewCoordinates(markers);
            this.lastNewMarkers = newMarkers;
        }
        this.removeMarkers();
        this.renderActive();
        this.setMarkers(newMarkers, 'new', active);
        this.reportMarkersCoordinates.forEach((element) => {
            let indexOfEl = -1;
            this.renderedMarkers.forEach((val, index) => {
                if(val[0] === element[0] && val[1] === element[1]){
                    this.renderedMarkers[index][2] = element[2];
                    indexOfEl = index;
                }
            });
            if(indexOfEl < 0){
                this.renderedMarkers.push(element);
            }
        })
    }

    renderActive () {
        const zoom = this.map.getZoom();
        if(zoom >= 13){
            this.removeMarkers();
            return;
        }
        const markers = this.getVisibleMarkers(this.renderedMarkers, true, 0);

        this.setMarkers(markers, 'old', false);
    }

    removeMarkers(){
        this.shapes.forEach((shape) => {
            this.map.removeLayer(shape);
        });
        
        this.shapes = [];
    }

    setMarkers (markers: any[], type: 'new'| 'old', active: boolean){
        let size = 32;
        let zIndex = 900;
        if(type == 'new'){
            size = 46;
            zIndex = 1000;
        }
        
        const icon =  new DivIcon({
            iconSize: new Point (size, size),
            iconAnchor: new Point(size, size),
            popupAnchor: [0, -20],
            className: 'marker-lightning',
            html: '<img src="'+Ray+'" class="light-img" width="'+size+'"  height="'+size+'" style="width: '+size+'px !important;height: '+size+'px !important" />'
        })
        markers.forEach((marker) => {
      
            const markerObject = {
                position: <LatLng>new LatLng(marker[0],marker[1]),
                icon: icon,
                cursor: 'hand',
                zIndex: zIndex,
                pane: 'overlayMarkersPane'
            }
            
            const markerElement: Layer = new Marker(markerObject.position, markerObject);
            if(!this.stopService){
                this.map.addLayer(markerElement);
                this.shapes.push(markerElement);
            }
          
        })
    }
    flash() {
        if(this.flashTimerId !== null){
            clearTimeout(this.flashTimerId);
        }
        this.flashTimerId = setTimeout(function(){
            document.querySelectorAll('.pulse-flash').forEach(element => element.remove());
        }, 5000);
    }

    getNewCoordinates(markers: any[]) {
        const newMarkers: any[] = [];
        markers.forEach((marker) => {
            let isExist = false;
            this.renderedMarkers.forEach((tracksContainer) => {
                if(typeof tracksContainer !== 'undefined' && tracksContainer[0] == marker[0] &&
                    tracksContainer[1] == marker[1]){
                    isExist = true;
                }
            })
            if(!isExist){
                newMarkers.push(marker);
            }
            
        });

        return newMarkers;
    }

    getVisibleMarkers (tracks: any[], active: boolean, timeMultiplier: number) {
        const zoom = this.map.getZoom();
        const borderSize = 32/500;

        const bounds = this.map.getBounds();
        const nn = bounds.getNorth();
        const ee = bounds.getEast();
        const ss = bounds.getSouth();
        const ww = bounds.getWest();
        const minLat = Math.min(nn, ss);
        const minLng = Math.min(ee, ww);
        const maxLat = Math.max(nn, ss);
        const maxLng = Math.max(ee, ww);
        const dLat = (maxLat - minLat)*borderSize;
        const dLng = (maxLng - minLng)*borderSize;

        const markers: any[] = [];

        tracks.forEach((track) => {
            if(!active) {
                const date = new Date();
                track[2] = date.getTime() - timeMultiplier*20*1000;
            }
            if(track[0] > minLat - dLat &&
                track[0] < maxLat + dLat &&
                track[1] > minLng - dLng &&
                track[1] < maxLng + dLng) {
                let oversight = 0.05;
                if(zoom > 6) {
                    oversight = 0;
                }
                if(!this.checkSQ(oversight, track, markers)){
                    markers.push(track);
                }
            }
        })
        return markers;
    }

    checkSQ(oversight: number, track: any[], markers: any []) {
        if(oversight == 0){
            return false;
        }
        for(const ii in markers){
            if(track[0] > markers[ii][0]-oversight &&
                track[0] < markers[ii][0]+oversight &&
                track[1] > markers[ii][1]-oversight &&
                track[1] < markers[ii][1]+oversight){
                return true;
            }
        }
        return false;
    }

    isJSON (jsonString: any[]) {
        try {
            return  Array.isArray(jsonString)? jsonString : [];
        }
        catch (e) { }

        return [];
    }
    
    parseData(data: any){
        const newLightningJson: any[] = [];
        const xml = new DOMParser().parseFromString(data, 'text/xml');
        let nodes = [];
        if(typeof xml.getElementsByTagName("glm")[0] !== 'undefined') {
            nodes = Array.prototype.slice.call(xml.getElementsByTagName("glm")[0].childNodes);
        }
        nodes.forEach((node) => {
            newLightningJson.push(node.attributes.path.value);
        })
        return newLightningJson;
    }

    startObservation () {
   
        this.clearIntervals();
        this.interval = setInterval(async () => {
            if (this.stopService) {
                this.clearIntervals();
                return
            }
            await this.checkLightningUpdates();
            this.clearOldMarkers();
        }, 20*1000);
    }
    
    clearIntervals(){
        if (this.interval) {
            clearInterval(this.interval);
        }
    }

    stopObservation() {
        this.stopService = true;
        this.clearIntervals();
        this.removeMarkers();
        this.reportMarkersCoordinates = [];
        this.renderedMarkers = [];
        this.lastNewMarkers = [];
        this.lightningReports = [];
        this.shapes = [];
    }

    async checkLightningUpdates() {
        try{
            const response =await axios.get(Constants.LIGHTNINGS_API_URL ?? '');
            this.lightningReports = this.parseData(response.data);
        }catch (e){
            console.log(e)
            this.lightningReports = [];
        }
        
        await this.getCoordinates(0);
        this.render(false, 0);
    }

    clearOldMarkers() {
        const date = new Date();
        this.renderedMarkers.forEach((mark: any, index) => {
            if (typeof mark !== 'undefined'){
                const shape = this.shapes.filter((tracksContainer: Layer) => (tracksContainer as Marker).getLatLng().lat == mark[0] && (tracksContainer as Marker).getLatLng().lng == mark[1]);

                if (date.getTime() - mark[2] > 20 * 1000) { // each 20 seconds
                    if (shape.length > 0) {
                        const tracksContainer= shape[0] as Marker;
                        const markerElement = tracksContainer.getElement();
                        if (markerElement) {
                            markerElement.style.opacity = '0.66';
                        }

                    }
                }
                //each 40 seconds
                if (date.getTime() - mark[2] > 40 * 1000) {
                    if (shape.length > 0) {
                        const tracksContainer = shape[0] as Marker;
                        const markerElement = tracksContainer.getElement();
                        if (markerElement) {
                            markerElement.style.opacity = '0.33';
                        }
                    }
                }

                if( date.getTime() - mark[2] > 60 * 1000){ // each 60 seconds
                    if(shape.length > 0){
                        this.map.removeLayer(shape[0]);
                        this.shapes.splice(this.shapes.indexOf(shape[0]), 1);
                        this.renderedMarkers.splice(index, 1);
                    }
                }
            }
        });
    }

    updateFrame() {
        this.render(true, 0);
    }

}
